/**
 * VideoSyncButton Component
 * Button to open Video Sync panel
 */

import React from 'react';
import { Button } from '../../ui/button';
import { Film } from 'lucide-react';

export const VideoSyncButton = ({ setShowVideoSync }) => (
  <Button
    variant="ghost"
    size="sm"
    onClick={() => setShowVideoSync(true)}
    className="relative p-2 text-zinc-400 hover:text-white hover:bg-cyan-500/20"
    data-testid="video-sync-btn"
    title="Video Sync"
  >
    <Film className="w-5 h-5" />
  </Button>
);

export default VideoSyncButton;
